export const objectToArray = (obj = {}) => Object.values(obj);
